import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Polyline, Marker } from "@react-google-maps/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useAxios from "../../../Hooks/useAxios";
import useMapLoader from "../../../Hooks/useMapLoader";
import MapData from "./MapData";

const HistoricalTrackViewer = () => {
  const [vehiclePlate, setVehiclePlate] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [trackData, setTrackData] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: -1.2921, lng: 36.8219 });
  const request = useAxios();

  const mapKey = process.env.REACT_APP_MAP_KEY;

  const isLoaded = useMapLoader(mapKey);

  const mapRef = useRef(null);
  const fetchTrackData = async () => {
    const res = await request({
      method: "GET",
      url: "deviceapis/historical-records",
      params: {
        FGUID: "4d88bb50-3b01-4730-be87-fb40fda45f02",
        FType: parseInt(2),
        FAssetTypeID: 400,
        FStartTime: startDate.toISOString(),
        FEndTime: endDate.toISOString(),
      },
      show_loading: true,
    });

    if (res !== "error") {
      const coordinates = res.FObject.map((item) => ({
        lat: item.Lat,
        lng: item.Lon,
      }));

      setTrackData(coordinates);

      if (coordinates.length > 0) {
        setMapCenter(coordinates[0]);

        // Zoom the map to fit the polyline with animation
        if (mapRef.current) {
          const bounds = new window.google.maps.LatLngBounds();
          coordinates.forEach((coord) => bounds.extend(coord));

          // Zoom with smooth animation
          mapRef.current.fitBounds(bounds);
          mapRef.current.panToBounds(bounds);
        }
      }
    }

    setStartDate(new Date());
    setEndDate(new Date());
  };

  const handleSearch = () => {
    fetchTrackData();
  };

  if (!isLoaded) {
    return <div>Loading Map...</div>;
  }

  return (
    <div
      className="p-4"
      style={{ display: "flex", flexDirection: "column", gap: "16px" }}
    >
    Hello
    <MapData/>
    </div>
  );
};

export default HistoricalTrackViewer;
